type BookIconProps = {
  strokeWidthThick?: number;
  strokeWidthThin?: number;
  fill?: string;
};

const BookIcon: React.FC<BookIconProps & React.SVGAttributes<SVGElement>> = ({
  strokeWidthThick = 4,
  strokeWidthThin = 2,
  fill,
  ...svgProps
}) => (
  <svg
    viewBox="40.391 33.914 139.522 101.4"
    width={139.522}
    height={101.4}
    fill="none"
    overflow="visible"
    {...svgProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.151 135.314V43.132s-15.502-9.218-34.88-9.218c-19.377 0-34.88 9.218-34.88 9.218v92.182s15.503-9.219 34.88-9.219c19.378 0 34.88 9.219 34.88 9.219Z"
      strokeWidth={strokeWidthThick}
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill={fill}
    />
    <path
      d="M53.472 60.415c5.777-1.778 12.931-3.264 20.71-3.264 7.778 0 14.932 1.486 20.71 3.264m-41.42 13.826c5.777-1.778 12.931-3.264 20.71-3.264 7.778 0 14.932 1.486 20.71 3.264m-41.42 13.826c5.777-1.778 12.931-3.263 20.71-3.263 7.778 0 14.932 1.485 20.71 3.263m-41.42 13.826c5.777-1.778 12.931-3.263 20.71-3.263 7.778 0 14.932 1.485 20.71 3.263"
      strokeWidth={strokeWidthThin}
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M179.913 135.314V43.132s-15.502-9.218-34.88-9.218-34.881 9.218-34.881 9.218v92.182s15.503-9.219 34.881-9.219 34.88 9.219 34.88 9.219Z"
      strokeWidth={strokeWidthThick}
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill={fill}
    />
    <path
      d="M125.397 60.464c5.777-1.779 12.931-3.264 20.71-3.264 7.779 0 14.933 1.485 20.71 3.264m-41.42 13.826c5.777-1.778 12.931-3.264 20.71-3.264 7.779 0 14.933 1.486 20.71 3.264m-41.42 13.826c5.777-1.778 12.931-3.264 20.71-3.264 7.779 0 14.933 1.486 20.71 3.264m-41.42 13.826c5.777-1.778 12.931-3.263 20.71-3.263 7.779 0 14.933 1.485 20.71 3.263"
      strokeWidth={strokeWidthThin}
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
  </svg>
);

export default BookIcon;
